import { render } from "./ServiceEstimatedBillDate.vue?vue&type=template&id=289b4245&scoped=true"
import script from "./ServiceEstimatedBillDate.vue?vue&type=script&lang=js"
export * from "./ServiceEstimatedBillDate.vue?vue&type=script&lang=js"

import "./ServiceEstimatedBillDate.vue?vue&type=style&index=0&id=289b4245&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289b4245"]])

export default __exports__